/**
 * 自动生成， 请不要手工修改！
 */

import { CustomRequest } from "../CustomRequest";
import {EntityRoleSpec} from "./EntityRoleSpec";
import {MessageType} from "../../../message/MessageContentType";
import {TypeFactory} from "../../../serialize/TypeFactory";

export abstract class AbstractEntityRoleRequest extends CustomRequest<EntityRoleSpec> {
  constructor() {
    super();
  }

    abstract getMessageType(): MessageType;

  public fillFromJson(json: Object, factory?: TypeFactory) {
    if (factory) {
      super.fillFromJson(json, factory);
    } else {
      super.fillFromJson(json);
    }
  }

  public fillToJson(json: Object, includeTypeTag = true) {
    super.fillToJson(json, includeTypeTag);

    if (includeTypeTag) {
      json["__type"] = "EntityRoleRequest";
    }
  }

  public getTypeId(): string {
    return "EntityRoleRequest";
  }

  public getClassName(): string {
    return "com.gong_wei.common.datatype.request.entity.EntityRoleRequest";
  }
}
